import { z } from "zod";

import { planInfoSchema } from "@smart/bridge-domains-basic";
import { supportedLanguageSchema, system } from "@smart/bridge-types-basic";
import { buildSNSSQSDef } from "@smart/itops-constructs-basic";
import { buildNamespace } from "@smart/itops-types-basic";
import { wrapSchema } from "@smart/itops-utils-basic";

const TranslationNS = buildNamespace({
  system,
  entity: "Translation",
} as const);

export const TranslationSchema = z.object({
  operationId: z.string(),
  info: planInfoSchema,
  formUri: z.string(),
  target: z
    .object({
      type: z.enum(["FORM", "FIELD", "SECTION", "GROUP"]),
      uri: z.string().optional(),
      changedProperties: z
        .array(
          z.enum([
            "label",
            "title",
            "description",
            "options",
            "repeatPrompt",
            "response",
            "aiFillSectionTitle",
            "aiFillFileUploadLabel",
            "aiFillFileUploadDescription",
          ]),
        )
        .optional(),
    })
    .optional(),
  supportedLanguages: z.array(supportedLanguageSchema),
});

const TranslationGuard = wrapSchema(TranslationSchema);

export const TranslationDef = buildSNSSQSDef({
  namespace: TranslationNS,
  guard: TranslationGuard,
  sqsOnly: false,
  groupKey: undefined,
  idKey: undefined,
  maxAttempts: 1,
  visibilityTimeout: 600,
});
